import { Pencil, Trash2 } from "lucide-react";
import { cn } from "../../lib/cn.js";

/**
 * Standard row-level icon buttons used by DataTable rows. Edit + delete are
 * the most common pair; pass `extras` to insert custom buttons before delete.
 */
export function RowActions({ onEdit, onDelete, extras, className }) {
  return (
    <div className={cn("inline-flex items-center gap-1", className)}>
      {extras}
      {onEdit && (
        <button
          type="button"
          onClick={onEdit}
          className="rounded p-1.5 text-text-secondary hover:bg-bg-elevated-2 hover:text-accent"
          title="Edit"
        >
          <Pencil className="h-4 w-4" />
        </button>
      )}
      {onDelete && (
        <button
          type="button"
          onClick={onDelete}
          className="rounded p-1.5 text-text-secondary hover:bg-danger/10 hover:text-danger"
          title="Delete"
        >
          <Trash2 className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
